module.exports = __webpack_public_path__ + "img/part5-24.30c10665.png";